export const Points = ({
  points,
  prefix,
  suffix,
}: {
  points?: number
  prefix?: string
  suffix?: string
}) => {
  return points ? (
    <span>
      {prefix ? `${prefix} ` : ''}
      {points.toFixed(2).replace(/0+$/, '').replace(/\.$/, '.0')}
      {suffix ? ` ${suffix}` : ''}
    </span>
  ) : null
}
